import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../services/firebase';
import { doc, getDoc } from 'firebase/firestore';

const SmartWholesaleHandler = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const checkWholesaleStatusAndRedirect = async () => {
            if (!currentUser) {
                // If not logged in, redirect to wholesale application page
                navigate('/wholesale');
                return;
            }

            try {
                // Check if user has a wholesale customer record
                const wholesaleDocRef = doc(db, 'wholesaleCustomers', currentUser.uid);
                const wholesaleDoc = await getDoc(wholesaleDocRef);

                if (wholesaleDoc.exists()) {
                    const wholesaleData = wholesaleDoc.data();
                    
                    if (wholesaleData.status === 'approved') {
                        // User is approved wholesale customer - redirect to dashboard
                        navigate('/wholesale-dashboard');
                    } else {
                        // User has applied but not yet approved - redirect to application page
                        navigate('/wholesale');
                    }
                } else {
                    // User hasn't applied for wholesale - redirect to application page
                    navigate('/wholesale');
                }
            } catch (error) {
                console.error('Error checking wholesale status:', error);
                // On error, default to wholesale application page
                navigate('/wholesale');
            }
        };

        checkWholesaleStatusAndRedirect();
    }, [currentUser, navigate]);

    // Show loading while redirecting
    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '50vh',
            fontSize: '18px'
        }}>
            Checking wholesale status...
        </div>
    );
};

export default SmartWholesaleHandler; 